/**
 * curseur.js
 */

// Import
import "./curseur.scss";
import $ from 'jquery';

if ( window.location.pathname == '/rentree/' ){
    const cursorRound = document.querySelector('.cursorRound');

    if(cursorRound){
        cursorRound.style.display = "block";
    
        const moveCursor = (e)=> {
          const mouseY = e.clientY;
          const mouseX = e.clientX;
           
          cursorRound.style.left = `${mouseX}px`;
          cursorRound.style.top = `${mouseY}px`;
        }
        
        window.addEventListener('mousemove', moveCursor)
        
        window.onload = () => {
            var links = document.querySelectorAll('a');
            links.forEach(link => {
                link.addEventListener("mouseenter", () => {
                    cursorRound.style.display = "none";
                });
                link.addEventListener("mouseleave", () => {
                    cursorRound.style.display = "block";
                });
            });
        }   
    }
}

